const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '项目信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '采购失败',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/app/track/zbProgressBaseInfo`, {
                bdGuid: this.form.bdGuid,
            }).then((res) => {
                this.config[1].options.data = {
                    '标段/包名称': res.data.bdName,
                    '标段/包编号': res.data.bdBH,
                    '项目类型': getProjectTypeName(res.data.xmLeiXing),
                    '采购方式': getPurchaseTypeName(res.data.zbFangShi),
                    '项目经理': res.data.projectManagerName,
                    '联系电话': res.data.lianXiRenPhone,
                }
            })
            this.getOtherData()
        },
        getOtherData() {
            const guid = this.form.businessKey.split(':')[1]
            this.$request.post(`/transformToAfter/app/fee/back/queryBaseInfo`, {
                zbYiChangGuid: guid,
            }).then((res) => {
                this.config[3].options.data = {
                    '采购失败名称': res.data.title,
                    // '采购失败类型': res.data.yiChangLeiXingoptions,
                    // '采购失败原因': '',
                    '采购方式': getPurchaseTypeName(res.data.zbFangShi),
                    // '转换采购方式': '',
                    '失败情况描述': res.data.yiChangShuoMing,
                }
            })
        },
        pass() {
            this.failedCommit()
        },
        fail(opinion) {
            this.failedCommit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
